<template>
    <div class="comment-reply" :id="'post-' + reply.id">
        <div class="profile-icon-m relative">
            <template v-if="reply.user().active_trophy">
                <template v-if="reply.user().active_trophy.icon">
                    <trophy :trophy="reply.user().active_trophy"
                            :showTitle="false"
                            :showDesc="false"
                            :size="20"
                            :displayOnFeed="true"
                            orientation="horizontal">
                    </trophy>
                </template>
            </template>
            <a :href="'/profile/' + reply.user().username">
                <img :src="reply.user().avatar" onerror="this.src='/img/avatar.png'">
            </a>
        </div>
        <div class="comment-text reply-text normal-text">
            <i :class="{'animate-toggle' : media_visible}" v-if="user" class="fa fa-ellipsis-v post-media-mobile-toggle reply-media-toggle extra-light-text float-right hover-opacity blue-bg no-select" @click="openMediaDropdown"></i>
            <div class="post-media reply-media no-select" v-if="user" v-show="media_visible" v-click-outside="closeMediaDropdown">
                <div class="media-item-wrapper inline-block hover" @click="setEditing(true, reply); closeMediaDropdown();"
                     v-if="!topic.closed && reply.permissions.includes('EDIT') && !isGIF">
                    <i class="fal fa-edit secondary-c-hover extra-light-text mimic-title"></i>
                    <span class="inline-block">{{ translations['fields.edit'] }}</span>
                </div>
                <div class="media-item-wrapper inline-block hover" @click="openPopup('delete_feed_item', {item: reply, type: 'reply'}); closeMediaDropdown();"
                     v-if="reply.permissions.includes('DELETE')">
                    <i class="fal fa-trash secondary-c-hover extra-light-text mimic-title"></i>
                    <span class="inline-block">{{ translations['fields.delete'] }}</span>
                </div>
            </div>
            <div class="message-content"
                 :class="{'highlighted-reply': reply.highlighted || focusReply}">
                <template v-if="reply.user().isAdmin && settings.admin_badge_image !== ''">
                    <img class="admin-badge" :src="settings.admin_badge_image"/>
                </template>
                <template v-else-if="reply.user().isModerator && settings.moderator_badge_image !== ''">
                    <img class="admin-badge" :src="settings.moderator_badge_image"/>
                </template>
                <a class="profile-link" :href="'/profile/' + reply.user().username">
                    <p class="profile-name hover-opacity">
                        {{ reply.user().name }}
                        <i v-if="topic.user().birth_date && stripYears(topic.user().birth_date) === stripYears(now)" class="far fa-birthday-cake secondary-c"></i>
                    </p>
                </a>
                <span v-html="replyContent" v-if="!editing_content"></span>
            </div>
            <!--<huddle-editor
                    v-if="reply.permissions.includes('EDIT')"
                    class="edit-reply-content"
                    :singleLine="true"
                    :customModel="reply.content"
                    :hiddenByDefault="true"
                    :uniqueKey="reply.id + '_edit'"
                    :allowEnterShift="true"
                    :submitOnEnter="true"
                    :closeOnEscape="true"
                    :mentions="true"
                    :customData="{item: reply}"
                    :mobileSendButton="true"
                    v-on:editorEnterEmit="submitEditItem">
            </huddle-editor>-->
            <huddle-editor-v2
                    v-if="reply.permissions.includes('EDIT') && editing_content"
                    class="edit-reply-content"
                    :single_line="true"
                    :allow_enter_shift="true"
                    :init_on_mount="true"
                    :cursor_to_end_on_init="true"
                    v-model="reply.content"
                    :submit_on_enter="true"
                    :submittable="true"
                    :gifs="true"
                    :emojis="true"
                    :mentions="true"
                    :channelId="topic.board_id"
                    :mobile_send_btn="true"
                    :customData="{item: reply}"
                    @keydown.esc.native="setEditing(false, reply)"
                    @submit="submitEditItem">
            </huddle-editor-v2>
            <div class="comment-details">
                <div class="comment-karma comment-desc-item extra-light-text inline tiny-text" v-if="reply.user().level && plugins.gamification">
                    Level {{ reply.user().level }}
                </div>
                <div class="comment-timestamp comment-desc-item extra-light-text tiny-text">
                    <i class="far fa-clock"></i>
                    {{ reply.created_at | getDateHumanFormat }}
                </div>
                <div class="like comment-like comment-desc-item extra-light-text mimic-title no-select tiny-text">
                    <p v-if="reply.likesCount" class="count" :class="{'secondary-c' : reply.liked_by_me}">
                        {{ reply.likesCount }}</p>
                    <p class="count" v-else>0</p>
                    <i class="far"
                       :class="[{'font-blue' : reply.liked_by_me}, {'secondary-c-hover': user && !topic.closed}, settings.like_icon]"
                       @click="likePost({id: reply.id, bool: !reply.liked_by_me, model: reply.plural, object: reply, closed: topic.closed})"></i>
                    <template v-if="user">
                        <span v-if="reply.likesCount > 0" class="like-names">
                            <template v-for="like in reply.likes()">
                                <span class="like-name">
                                    {{ like.name }}
                                </span>
                                <br>
                            </template>
                        </span>
                        <span v-else class="like-names">
                            <span class="like-name empty-likes">{{ translations['social.no_likes_first'] }}!</span><br/>
                        </span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //mixins
    import {mapState} from 'vuex';
    import Feed from '../../mixins/Feed.js'
    import Global from '../../mixins/Global.js'
    import Moment from '../../mixins/Moment.js';
    import Modal from '../../mixins/v2/Modal';

    export default {
        mixins: [Feed, Global, Moment, Modal],
        name: 'Reply',

        props: [
            'topic',
            'comment',
            'reply',
            'focusCommentByHashId'
        ],

        computed: {
            ...mapState([
                'settings',
                'plugins'
            ]),

            replyContent() {
                return this.contentFilter(this.reply, false, false);
            },

            focusReply() {
                if(parseInt(this.focusCommentByHashId) === this.reply.id) {
                    //set the highlight variable of the comment to true
                    this.$store.commit('highlightFeedItem', {item: this.reply});

                    let options = {
                        offset: -300
                    };

                    this.$nextTick(() => {
                        this.$scrollTo('#post-' + this.reply.id, 500, options);
                    });

                    return true;
                }

                return false;
            },

            isGIF() {
                return this.reply.content.indexOf('https://media.tenor.com') !== -1;
            },
        },
    }
</script>

<style lang="scss">

</style>